var request_config = {
    appDomain: 'api.allfootballapp.com',
    apiDomain: 'm-api.allfootballapp.com',
    staticDomain: 'allfootball-static.dongqiudi.com/n',
    apiDomain2: 'api.allfootballapp.com',
    apiDomain3: 'article.allfootballapp.com'
};

module.exports = {
    appDomain: 'https://'+request_config.appDomain,
    apiDomain: 'https://'+request_config.apiDomain,
    staticDomain: 'https://'+request_config.staticDomain,
    apiDomain2: 'https://' + request_config.apiDomain2,
    apiDomain3: 'https://' + request_config.apiDomain3
};




//////////////////
// WEBPACK FOOTER
// ./bin/config.js
// module id = 82
// module chunks = 17